import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

/**
 * Componente de filtros para productos
 * @param {Object} props
 * @param {Object} props.filtros - Estado de filtros
 * @param {Function} props.onFiltroChange - Handler para cambios en filtros
 * @param {Function} props.onLimpiar - Handler para limpiar filtros
 * @param {Object} props.valoresUnicos - Valores únicos para selects
 */
function FiltrosProductos({ filtros, onFiltroChange, onLimpiar, valoresUnicos }) {
  return (
    <div className="admin-form-container mb-4">
      <Row className="g-3 align-items-end">
        <Col xs={12} sm={6} md={2}>
          <Form.Group className="admin-form-group">
            <Form.Label className="admin-form-label small">Categoría</Form.Label>
            <Form.Select
              name="categoria"
              value={filtros.categoria}
              onChange={onFiltroChange}
              size="sm"
              className="admin-form-select"
            >
              <option value="">Todas</option>
              {valoresUnicos.categorias.map(categoria => (
                <option key={categoria} value={categoria}>
                  {categoria}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <Form.Group className="admin-form-group">
            <Form.Label className="admin-form-label small">Material</Form.Label>
            <Form.Select
              name="material"
              value={filtros.material}
              onChange={onFiltroChange}
              size="sm"
              className="admin-form-select"
            >
              <option value="">Todos</option>
              {valoresUnicos.materiales.map(material => (
                <option key={material} value={material}>
                  {material}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <Form.Group className="admin-form-group">
            <Form.Label className="admin-form-label small">Color</Form.Label>
            <Form.Select
              name="color"
              value={filtros.color}
              onChange={onFiltroChange}
              size="sm"
              className="admin-form-select"
            >
              <option value="">Todos</option>
              {valoresUnicos.colores.map(color => (
                <option key={color} value={color}>
                  {color}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <Form.Group className="admin-form-group">
            <Form.Label className="admin-form-label small">Modelo</Form.Label>
            <Form.Control
              type="text"
              name="modelo"
              value={filtros.modelo}
              onChange={onFiltroChange}
              placeholder="Buscar por modelo..."
              size="sm"
              className="admin-form-control"
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <Form.Group className="admin-form-group">
            <Form.Label className="admin-form-label small" style={{ visibility: 'hidden' }}>Limpiar Filtros</Form.Label>
            <div className="d-flex justify-content-end">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={onLimpiar}
                style={{ 
                  minWidth: '100px',
                  borderColor: '#28a745',
                  color: '#28a745'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#28a745';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#28a745';
                }}
              >
                Limpiar Filtros
              </Button>
            </div>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
}

export default FiltrosProductos;

